import { render } from "./Group-add.vue?vue&type=template&id=2d458955"
import script from "./Group-add.vue?vue&type=script&lang=js"
export * from "./Group-add.vue?vue&type=script&lang=js"

import "./Group-add.vue?vue&type=style&index=0&id=2d458955&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__